export const legal = {
  title: 'Legal',
  terms: {
    title: 'Terms of Service'
  },
  privacy: {
    title: 'Privacy Policy'
  },
  cookies: {
    title: 'Cookie Policy'
  },
  copyright: '© {{year}} SynthoHosting. All rights reserved.'
};